import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Apple(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.13 17.59c-.3.7-.65 1.34-1.06 1.93-.55.8-1 1.36-1.35 1.67a2.6 2.6 0 01-1.74.79c-.45 0-.98-.13-1.6-.4-.64-.26-1.21-.39-1.74-.39-.55 0-1.14.13-1.78.4a4.7 4.7 0 01-1.54.4c-.6.03-1.18-.23-1.78-.8-.37-.33-.85-.91-1.41-1.73a12.1 12.1 0 01-1.5-3.04A11.37 11.37 0 014 12.79c0-1.34.28-2.5.85-3.46a5.05 5.05 0 011.78-1.85 4.71 4.71 0 012.4-.7c.48 0 1.1.16 1.87.45.77.3 1.26.45 1.48.45.16 0 .7-.18 1.64-.53a5.3 5.3 0 012.22-.4 4.7 4.7 0 013.7 2 4.23 4.23 0 00-2.18 3.82 4.27 4.27 0 001.36 3.18c.4.4.85.7 1.35.9-.1.33-.22.64-.34.94zM16.35 2.4c0 1-.35 1.93-1.07 2.8-.86 1.03-1.9 1.62-3.02 1.53a4.44 4.44 0 011.11-3.2c.36-.44.82-.79 1.38-1.07A4.05 4.05 0 0116.33 2c.02.13.02.27.02.4z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Apple);
export default ForwardRef;